/* eslint-disable import/prefer-default-export */
// until more than 1 export
export const getNotifications = state => state.get('notifications');
